import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Create, Add, FolderShared, Visibility } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsGetAll } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import Badge from 'components/Badge/Badge';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 165 },
  { Header: 'Cód. provedor', accessor: 'CardCode', width: 130 },
  { Header: 'provedor', accessor: 'CardName' },
  { Header: 'Categoría', accessor: 'logi_category_description', excelEnabled: false },
  { Header: 'Familia', accessor: 'logi_family_description', excelEnabled: false },
  { Header: 'Línea', accessor: 'logi_line_description', excelEnabled: false, width: 200 },
  { Header: 'Marca', accessor: 'logi_mark_description', width: 200 },
  { Header: 'Mesa', accessor: 'base_bureau_description', width: 200 },
  { Header: 'Precio Mayorista', accessor: 'mayorista_validation', width: 200 },
  { Header: 'Estado', accessor: 'state', width: 100 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 5 },
];

export default WithApp(function Portfolio(props) {
  const classes = useStyles();

  const [notify, showNotify] = useToasty();
  const [model, setOpen] = useModal();

  const [portfolios, setPorfolios] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  async function listPortfolios() {
    setDataLoading(true);
    let response = await wsGetAll('logi/portfolio');
    setDataLoading(false);
    if (response.success) setPorfolios(response.data);
  }

  useEffect(() => {
    listPortfolios();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <Modal model={model} setOpen={setOpen} showNotify={showNotify} reload={listPortfolios} />

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.LOGI_PORTFOLIOS_STORE}
              component={
                <CardIcon color="primary">
                  <FolderShared style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado de portafolios {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="Portafolios"
              defaultWidth={2000}
              columns={columns}
              data={portfolios.map((portfolio, i) => {
                const noAssignedBag = (
                  <div className="actions-center">
                    <Badge color="info">No asignado</Badge>
                  </div>
                );
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.LOGI_PORTFOLIOS_UPDATE}>
                        <Button
                          justIcon
                          round
                          simple
                          color="warning"
                          onClick={() => setOpen(portfolio)}
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.LOGI_PORTFOLIOS_SHOW}>
                        <Link to={`${portfolio.id}`}>
                          <Button justIcon round simple color="primary">
                            <Visibility />
                          </Button>
                        </Link>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.LOGI_PORTFOLIOS_DELETED}>
                        <ButtonDelete
                          entity="logi/portfolio"
                          id={portfolio.id}
                          reload={listPortfolios}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  CardCode: portfolio.CardCode,
                  CardName: portfolio.CardName,
                  logi_category_description: portfolio.logi_category_description ?? noAssignedBag,
                  logi_family_description: portfolio.logi_family_description ?? noAssignedBag,
                  logi_line_description: portfolio.logi_line_description ?? noAssignedBag,
                  logi_mark_description: portfolio.logi_mark_description ?? noAssignedBag,
                  base_bureau_description: portfolio.base_bureau_description,
                  mayorista_validation: portfolio.mayorista_validation === 'Y' ? 'Aplicar' : 'No aplicar',
                  state: portfolio.state === 'A' ? 'Activo' : 'Inactivo',
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
